define((require) => {
    "use strict";

    const AbstractWidgetView                = require("shared/ui/experience/widgets/AbstractWidgetView");
    const SalesforceCommerceQuickViewAction = require("../action/SalesforceCommerceQuickViewAction");

    /**
     * The view rendering an SalesforceCommerce widget.
     *
     * @class SalesforceCommerceWidgetView
     * @constructor
     *
     * @cfg {SalesforceCommerceWidgetModel} model The model of the SalesforceCommerce widget being rendered.
     */
    return AbstractWidgetView.extend("SalesforceCommerceWidget", {

        tagName: "div",

        className: `${AbstractWidgetView.prototype.className} salesforce-commerce-widget`,

        transient: ["action"], // created on the fly, no need to persist (editor specific)

        constructor() {
            this.__super();

            // Create action to handle the Quickview integration; if no product id has been set yet, the action
            // is not activateable...
            const action = new SalesforceCommerceQuickViewAction({productID: this.model.get("productID")});
            const options = {silent: true};

            // Set backing action silently; it is an implementation detail we do not expose directly to the
            // world as is...
            this.model.set("action", action, options);

            // Make sure we update the backing action according to the product id set...
            this.listenTo(this.model, "change:productID", (model, productID) => { // really only ever in the Editor
                action.set("productID", productID, options);
            });
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/salesforceCommerceWidget/view/SalesforceCommerceWidgetView.js